
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  data() {
    return {};
  },
  computed: {
    ...mapState("app", {
      language: "language",
      isCN: "isCN",
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      url: "url",
      oss: "oss"
    }),
    communityImages(): string[] {
      return [
        this.oss.am_emptiness_phonecase_17_swiper_01,
        this.oss.am_emptiness_phonecase_17_swiper_02,
        this.oss.am_emptiness_phonecase_17_swiper_03,
        this.oss.am_emptiness_phonecase_17_swiper_04,
        this.oss.am_emptiness_phonecase_17_swiper_05,
        this.oss.am_emptiness_phonecase_17_swiper_06,
        this.oss.am_emptiness_phonecase_17_swiper_07,
        this.oss.am_emptiness_phonecase_17_swiper_08,
        this.oss.am_emptiness_phonecase_17_swiper_09,
        this.oss.am_emptiness_phonecase_17_swiper_10,
        this.oss.am_emptiness_phonecase_17_swiper_11,
        this.oss.am_emptiness_phonecase_17_swiper_12
      ];
    },
    communityNames(): string[] {
      return this.isCN
        ? [
            "by 用户名1",
            "by 用户名2",
            "by 用户名3",
            "by 用户名4",
            "by 用户名5",
            "by 用户名6",
            "by 用户名7",
            "by 用户名8",
            "by 用户名9",
            "by 用户名10",
            "by 用户名11",
            "by 用户名12"
          ]
        : [
            "by Username1",
            "by Username2",
            "by Username3",
            "by Username4",
            "by Username5",
            "by Username6",
            "by Username7",
            "by Username8",
            "by Username9",
            "by Username10",
            "by Username11",
            "by Username12"
          ];
    }
  },
  methods: {}
});
